import styled from "@emotion/styled";

export const ClickableDiv = styled.div`
  ${({ onClick }) => (onClick !== undefined ? "cursor: pointer;" : "")}
`;
